import { render, staticRenderFns } from "./productTag.vue?vue&type=template&id=794b0091&scoped=true&"
import script from "./productTag.vue?vue&type=script&lang=js&"
export * from "./productTag.vue?vue&type=script&lang=js&"
import style0 from "./productTag.vue?vue&type=style&index=0&id=794b0091&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b0091",
  null
  
)

export default component.exports